// Snapshot the FB pixel browser signals so we can forward them to the
// backend → Stripe metadata → CAPI webhook for higher Event Match Quality.
//
// `_fbp` is set by the FB pixel on first PageView (cookie scoped to our
// domain). `_fbc` is set when the user lands with `fbclid=...` in the URL.
// Both are short tokens, plain ASCII, safe to round-trip via Stripe metadata
// (500-char limit per value — we have plenty of headroom).

function readCookie(name) {
  if (typeof document === 'undefined' || !document.cookie) return '';
  const target = `${name}=`;
  const parts = document.cookie.split(';');
  for (let i = 0; i < parts.length; i += 1) {
    const c = parts[i].trim();
    if (c.startsWith(target)) return c.slice(target.length);
  }
  return '';
}

export function getFbTrackingPayload() {
  return {
    fb_fbp: readCookie('_fbp'),
    fb_fbc: readCookie('_fbc'),
    fb_source_url: typeof window !== 'undefined' ? window.location.href : '',
  };
}
